// extracted by mini-css-extract-plugin
module.exports = {"title":"details_title__pBvVF","agreementbox":"details_agreementbox__11mHf"};